var contactmodal = {
  eyebrow: "Contacto",
  heading: "Ponte en contacto",
  intro: "Ponte en contacto con nosotros para detalles de comisiones y consultas generales.",
  closeLabel: "Cerrar información de contacto",
  roles: {
    redemptionCoordinator: "Coordinadora de Redención",
    businessDevelopment: "Gerente Senior de Desarrollo de Negocios",
  },
};

module.exports = contactmodal;
